import "./App.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import HomeScreen from "./screens/HomeScreen";

import Forms from "./forms/Forms";

import Layout from "./screens/Layout";

import About from "./components/About";
import Login from "./screens/Login";
import RegionScreen from "./screens/RegionScreen";
import GroupScreen from "./screens/GroupScreen";
import NoAccess from "./screens/NoAccess";

// Group FORM A
import GroupFormA from "./forms/group/GroupFormA";
import GroupFormAForm from "./forms/group/GroupFormAForm";
import GroupFormAResponse from "./forms/group/GroupFormAResponse";

// Group FORM B
import FormBApp from "./forms/group/FormB/FormBApp";
import GroupFormBResponse from "./forms/group/GroupFormBResponse";
import GroupFormB from "./forms/group/GroupFormB";

// import MangalyatraScreen from "./mangalyatra/MangalyatraScreen";

import FormerPresident from "./screens/FormerPresident";

import FedIDScreen from "./screens/FedIDScreen";
import FedOBScreen from "./screens/FedOBScreen";
import Founders from "./screens/Founders";
import Ventures from "./screens/Ventures";
import Oath from "./screens/Oath";
import Constitution from "./screens/Constitution";
import Constitution16 from "./screens/Constitution16";
import Kartavya from "./screens/Kartavya";
import Samvid from "./screens/Samvid";

import Eminence from "./ventures/Eminence";
import Gurukul from "./ventures/Gurukul";
import Udaan from "./ventures/Udaan";

import AainaForm from "./forms/group/AainaForm";
import AainaResponse from "./forms/group/AainaResponse";
import Aaina from "./forms/group/Aaina";
import GrpEventScreen from "./events/GrpEventScreen";

import Pari from "./ventures/Pari";

import EditProfile from "./screens/EditProfile";

import GroupFormAEditForm from "./forms/group/GroupFormAEditForm";

import GrpEventUpload from "./events/GrpEventUpload";
import PariForm from "./forms/pari/PariForm";
import PariResponse from "./forms/pari/PariResponse";

import UdaanForm from "./forms/udaan/UdaanForm";
import UdaanResponse from "./forms/udaan/UdaanResponse";
import FormBEditApp from "./forms/group/EditFormB/FormBEditApp";

import GrpEventEdit from "./events/GrpEventEdit";
import EminenceGrp1Response from "./forms/eminence/EminenceGrp1Response";
import EminenceGrp1Form from "./forms/eminence/EminenceGrp1Form";
import EminenceGrp1List from "./forms/eminence/EminenceGrp1List";
import FedCommittee from "./screens/FedCommittee";
import FedEvents from "./events/FedEvents";

import ThemeSong from "./screens/ThemeSong";
import NavkarMahamantra from "./screens/NavkarMahamantra";
import LogoDownloads from "./screens/LogoDownloads";
import Testimonials from "./screens/Testimonials";
import MediaCoverages from "./screens/MediaCoverages";
import ConstitutionIndex from "./screens/ConstitutionIndex";
import SrcBank from "./screens/SrcBank";

import GroupBanner from "./screens/banner/GroupBanner";
import RegionBanner from "./screens/banner/RegionBanner";
import ZoomBGReg from "./screens/zoom/ZoomBGReg";
import Rnr from "./screens/Rnr";
import Sop from "./screens/Sop";
import SecConstitution from "./screens/SecConstitution";
import SgnConstitution from "./screens/SgnConstitution";
import JSONUserUploader from "./components/JSONUserUploader";
import UdaanList from "./forms/udaan/UdaanList";
import EminenceGrp2List from "./forms/eminence/EminenceGrp2List";
import EminenceGrp2Form from "./forms/eminence/EminenceGrp2Form";
import EminenceGrp2Response from "./forms/eminence/EminenceGrp2Response";
import EminenceGrp3List from "./forms/eminence/EminenceGrp3List";
import EminenceGrp3Form from "./forms/eminence/EminenceGrp3Form";
import EminenceGrp3Response from "./forms/eminence/EminenceGrp3Response";
import EminenceGrp4List from "./forms/eminence/EminenceGrp4List";
import EminenceGrp4Form from "./forms/eminence/EminenceGrp4Form";
import EminenceGrp4Response from "./forms/eminence/EminenceGrp4Response";
import EminenceGrp5List from "./forms/eminence/EminenceGrp5List";
import EminenceGrp5Form from "./forms/eminence/EminenceGrp5Form";
import EminenceGrp5Response from "./forms/eminence/EminenceGrp5Response";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Layout />} exact>
            <Route path="" element={<HomeScreen />} />
            <Route path="not-allowed" element={<NoAccess />} />
            <Route path="aboutus" element={<About />} />
            <Route path="region/:regName" element={<RegionScreen />} />
            <Route path="group/:grpName" element={<GroupScreen />} />

            <Route path="/samvid" element={<Samvid />} />
            <Route path="/kartavya" element={<Kartavya />} />
            <Route path="/constitution" element={<Constitution />} />
            <Route
              path="/constitution-16-20-2020"
              element={<Constitution16 />}
            />
            <Route path="/constitution-index" element={<ConstitutionIndex />} />
            <Route path="oath-of-office" element={<Oath />} />
            <Route path="user/edit-profile/:id" element={<EditProfile />} />

            <Route path="former-presidents" element={<FormerPresident />} />
            <Route path="founders" element={<Founders />} />
            <Route path="fed/ob/:term" element={<FedOBScreen />} />
            <Route path="fed/id/:term" element={<FedIDScreen />} />
            <Route path="fed/committee/:term" element={<FedCommittee />} />
            <Route path="grp/events" element={<FedEvents />} />

            <Route path="grp/event/:id" element={<GrpEventScreen />} />
            <Route path="upload/grp/event/" element={<GrpEventUpload />} />

            <Route path="edit/grp/event/:id" element={<GrpEventEdit />} />

            <Route path="ventures" element={<Ventures />} />

            {/* <Route path="ventures/eminence" element={<Eminence />} /> */}
            <Route path="ventures/gurukul" element={<Gurukul />} />
            <Route path="ventures/pari" element={<Pari />} />
            <Route path="ventures/udaan" element={<Udaan />} />

            <Route path="login" element={<Login />} />

            {/* Aaina */}
            {/* <Route path="/aaina" element={<MangalyatraScreen />} /> */}

            <Route path="aaina" element={<Aaina />} />
            <Route path="aaina-response/:id" element={<AainaResponse />} />
            <Route path="form/aaina" element={<AainaForm />} />

            {/* Group Forms */}
            <Route path="grp-form-a" element={<GroupFormA />} />
            <Route path="form/grp-form-a" element={<GroupFormAForm />} />
            <Route
              path="form/grp-form-a/:id/edit"
              element={<GroupFormAEditForm />}
            />
            <Route
              path="grp-form-a-response/:id"
              element={<GroupFormAResponse />}
            />

            <Route path="grp-form-b" element={<GroupFormB />} />
            <Route path="form/grp-form-b" element={<FormBApp />} />
            <Route path="form/grp-form-b/:id/edit" element={<FormBEditApp />} />
            <Route
              path="grp-form-b-response/:id"
              element={<GroupFormBResponse />}
            />

            {/* Eminence Forms */}
            <Route path="list/eminence/1" element={<EminenceGrp1List />} />
            <Route path="form/eminence/1" element={<EminenceGrp1Form />} />
            <Route
              path="eminence/1/response/:id"
              element={<EminenceGrp1Response />}
            />
            <Route path="list/eminence/2" element={<EminenceGrp2List />} />
            <Route path="form/eminence/2" element={<EminenceGrp2Form />} />
            <Route
              path="eminence/2/response/:id"
              element={<EminenceGrp2Response />}
            />

            <Route path="list/eminence/3" element={<EminenceGrp3List />} />
            <Route path="form/eminence/3" element={<EminenceGrp3Form />} />
            <Route
              path="eminence/3/response/:id"
              element={<EminenceGrp3Response />}
            />

            <Route path="list/eminence/4" element={<EminenceGrp4List />} />
            <Route path="form/eminence/4" element={<EminenceGrp4Form />} />
            <Route
              path="eminence/4/response/:id"
              element={<EminenceGrp4Response />}
            />

            <Route path="list/eminence/5" element={<EminenceGrp5List />} />
            <Route path="form/eminence/5" element={<EminenceGrp5Form />} />
            <Route
              path="eminence/5/response/:id"
              element={<EminenceGrp5Response />}
            />

            {/* Pari Forms */}
            <Route path="form/pari-application-form" element={<PariForm />} />
            <Route
              path="pari-application-form/response/:id"
              element={<PariResponse />}
            />

            {/* Udaan Forms */}
            <Route path="list/udaan" element={<UdaanList />} />
            <Route path="form/udaan-group-form" element={<UdaanForm />} />
            <Route
              path="udaan-group-form/response/:id"
              element={<UdaanResponse />}
            />

            {/* Eminence Forms */}
            <Route path="theme-song" element={<ThemeSong />} />
            <Route path="navkar-mahamantra" element={<NavkarMahamantra />} />
            <Route path="logo-downloads" element={<LogoDownloads />} />
            <Route path="testimonials" element={<Testimonials />} />
            <Route path="media-coverages" element={<MediaCoverages />} />
            <Route path="reg/rnr" element={<Rnr />} />
            <Route path="reg/sop" element={<Sop />} />
            <Route
              path="reg/sangini-constitution"
              element={<SgnConstitution />}
            />
            <Route
              path="reg/secunderabad-constitution"
              element={<SecConstitution />}
            />
            <Route path="bulk-users" element={<JSONUserUploader />} />

            <Route path="reg/bank-details" element={<SrcBank />} />
            <Route path="banner-download/group/" element={<GroupBanner />} />
            <Route path="banner-download/region/" element={<RegionBanner />} />
            <Route path="reg/zoom-background/" element={<ZoomBGReg />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
